import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {  ServiceResponseModule } from '@sdbn/common';
import { TransportOptionsComponent } from './transport-options.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../../../../components/transport-options-panel/transport-options-panel.module';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    TransportOptionsPanelModule
  ],
  declarations: [
    TransportOptionsComponent
  ]
})
export class TransportOptionDetailsModule { }
